import BN from 'bn.js';

function getNonce(web3) {
    //Todo:: This isn't 100% guaranteed safe as we could conceivably get nonce collisions
    //Since we are using a UNIT_256 we the chances of a collision are very low though.
    return new BN(web3.utils.randomHex(32).replace('0x', ''), 16);
}

export { getNonce }